const SAFE_PARENT_TABS = new Set([
  'reports',
  'settings',
  'upgrade',
  'affiliate',
  'about',
]);

export function parentGatePathForTab(tab) {
  return SAFE_PARENT_TABS.has(tab)
    ? `/parent-gate?next=${tab}`
    : '/parent-gate';
}

export function parentDashboardPathForGateNext(next) {
  return SAFE_PARENT_TABS.has(next)
    ? `/parent?tab=${next}`
    : '/parent';
}
